export default __webpack_public_path__ + "static/media/notification_icon.54d4e7d8.svg";